import { render, staticRenderFns } from "./loyaltyProgram.vue?vue&type=template&id=00d92979&scoped=true&"
var script = {}
import style0 from "./loyaltyProgram.vue?vue&type=style&index=0&id=00d92979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d92979",
  null
  
)

export default component.exports